function updateIcon(btn, liked) {
	const icon = btn.querySelector(".icon");
	if (!icon) return;

	icon.classList.remove("icon-liked", "icon-not-liked");
	icon.classList.add(liked ? "icon-liked" : "icon-not-liked");

	btn.setAttribute("aria-pressed", liked ? "true" : "false");
}

export function initBarLikes() {
	// Only run if localized config exists
	if (typeof window.BarLike === "undefined") return;

	const handleToggle = async (btn) => {
		const postId = btn.getAttribute("data-post-id");
		if (!postId) return;

		// LOOP-SAFE: find the count element inside THIS like-wrap/card
		// (preferred markup: <span class="like-count">123</span> inside .like-wrap)
		const countEl = btn.querySelector(".like-count");

		const lockKey = `bar_liked_${postId}`;

		// Prevent rage-click spamming
		btn.style.pointerEvents = "none";

		try {
			const form = new FormData();
			form.append("action", "bar_like_toggle");
			form.append("nonce", window.BarLike.nonce);
			form.append("post_id", postId);

			const res = await fetch(window.BarLike.ajaxUrl, {
				method: "POST",
				credentials: "same-origin",
				body: form,
			});

			const json = await res.json();
			if (!json.success) throw new Error(json.data?.message || "Toggle failed.");

			const { liked, count } = json.data;

			if (countEl) countEl.textContent = count;

			if (liked) localStorage.setItem(lockKey, "1");
			else localStorage.removeItem(lockKey);

			updateIcon(btn, liked);
		} catch (err) {
			console.error(err);
			alert("Couldn’t update like right now.");
		} finally {
			btn.style.pointerEvents = "auto";
		}
	};

	// Click support (works in loops)
	document.addEventListener("click", (e) => {
		const btn = e.target.closest("[data-bar-like]");
		if (!btn) return;
		e.preventDefault();
		handleToggle(btn);
	});

	// Keyboard accessibility (works in loops)
	document.addEventListener("keydown", (e) => {
		if (e.key !== "Enter" && e.key !== " ") return;

		const btn = e.target.closest("[data-bar-like]");
		if (!btn) return;

		e.preventDefault();
		handleToggle(btn);
	});

	// Initialize icon state for all like-wrappers in loops
	document.querySelectorAll("[data-bar-like]").forEach((btn) => {
		const postId = btn.getAttribute("data-post-id");
		if (!postId) return;

		const lockKey = `bar_liked_${postId}`;
		const liked = localStorage.getItem(lockKey) === "1";
		updateIcon(btn, liked);
	});
}